module.exports = __webpack_public_path__ + "static/5-min-d673b2a2275c386f0d5e83c85fc0f59d.jpeg";